/* eslint-disable no-console */
import { httpModuleFormData } from '@shared/http';

export type AttachmentType = 'AccountTransaction' | 'TenantTransaction' | 'Tenant' | 'Guarantor';

export async function postUploadFile(file: File, type: AttachmentType) {
    try {
        const fileForm = new FormData();
        fileForm.append('file', file);
        const config = {
            maxContentLength: 200000
        };
        return await httpModuleFormData.post(`/attached?type=${type}`, fileForm, config);
    } catch (ex) {
        console.warn('Error uploading file');
        console.log(ex);
    }
}
